module.exports = __webpack_public_path__ + "img/ebcKr.1ef97c23.png";